import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSort, MatTableDataSource } from "@angular/material";
import { DRenta210IngresoServicios } from "@dian-api/renta210-ingreso";
import { DContextoMuisca, DLogger } from "@dian/core";
import {
  DListaDocumentos,
  DInfoResumenFormulario,
  DFirmaElectronica,
} from "@dian/api-formulario";
import { DNotificacionServicio } from "@dian-cmp/notificaciones";
import { MatDialog } from "@angular/material";
import { GeneralService } from "../../services/general.service";
import { DIdentificadorDocumento } from "../identificadorDocumento/didentificador-documento";
import { DOperacionesGeneralesIngresoServicio } from "@dian-cmp/formulario";
import { DVersionRutaFormato } from '@dian/api-formulario';

import { InfoFormularios } from "../models/infoFormularios";
import { DFormularioConfiguracion } from "../../configuracion/dformulario-configuracion";
import { Router } from "@angular/router";
import { DLiquidacionRecibo } from "@dian-api/recibo-pago490";
import { DEnvioDataServicio } from "@dian-cmp/recibo-pago";
import { DRtaLiquidacionReciboPago } from "@dian-api/recibo-pago490-exterior";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-definitivos",
  templateUrl: "./definitivos.component.html",
  styleUrls: ["./definitivos.component.css"],
  providers: [DRenta210IngresoServicios],
})
export class DefinitivosComponent implements OnInit {
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  private arrDocumentosDefinitivos: DListaDocumentos;
  private operacionesGenerales: DOperacionesGeneralesIngresoServicio;
  private estadosCarga = {
    pendientes: false,
    presentados: false,
    definitivos: false,
    anios: false,
  };
  private esFirmanteElectronico: DFirmaElectronica;
  private firmaRequerida: boolean = false;
  private fraccionAnio:boolean = true;
  private aniosFraccion = [];
  private enProceso:boolean = true;
  versionesRuta: Array<DVersionRutaFormato> = [];
  displayedColumns = [
    "num_formulario",
    "anio_frecuencia",
    "acciones",
  ];
  datosUsuario: DContextoMuisca;
  dataDefinitivos: InfoFormularios[] = [];
  dataSource = new MatTableDataSource(this.dataDefinitivos);
  datosFirmaYGrancondtribuyente?: {esFirmaElectronica: boolean; granContribuyente: boolean};
  tabs: any = {
    generarRecibo: {value: true, title: 'Generar Recibo'},
    previsualizar: {value: false, title: 'Previsualizar'},
    datosPago: {value: false, title: 'Datos de pago'},
  }
  currentTab = this.tabs.generarRecibo;
  contexto : DContextoMuisca;
  fecha: string;
  liquidacion: DLiquidacionRecibo;
  mensajeAntesGuardar: string;
  pagoPSE: boolean;
  tieneFirmaElectronica: boolean;
  pagando = false;
  formulario490 = new DRtaLiquidacionReciboPago;
  fechaPago = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  fechaHoy: Date = new Date();
  listCuotas: number[] = [];

  constructor(
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private logger: DLogger,
    private generalService: GeneralService,
    private dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private configuracionFormulario: DFormularioConfiguracion,
    private router: Router,
    private denvioData: DEnvioDataServicio,
    private datePipe: DatePipe
  ) {
    this.generalService.datosRespuesta$.subscribe((res) => {
      this.datosUsuario = res;
    });
    this.generalService.datosFirmaYTipoContribuyente$.subscribe(res =>{
      this.datosFirmaYGrancondtribuyente = res;
      if(res.esFirmaElectronica){
        this.router.navigate(['/']);
      }
    });

    this.denvioData.cambiaFlujo$.subscribe(data => {
      this.changeTab(data);
    })

    this.denvioData.reciboPago$.subscribe(res => {
      this.formulario490 = res ;
    })

    this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(
      this.dNotificacionServicio,
      this.dServicioRESTAPI,
      this.dialog
    );
    this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);

  }

  ngOnInit() {
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
    if (!this.datosFirmaYGrancondtribuyente) {
      this.datosFirmaYGrancondtribuyente = this.generalService.getDatosFirmaYGranContribuyente();
      if(this.datosFirmaYGrancondtribuyente && this.datosFirmaYGrancondtribuyente.esFirmaElectronica){
        this.router.navigate(['/']);
      }
    }
    setTimeout(() => {
      this.consultarFirmanteElectronico("desconocido"); //Esta linea inicia todo el proceso de la clase abstracta
    }, 50);
    this.obtenerDocsDefinitivos();
  }

  buildCuotas() {
    if (Number(this.liquidacion.totalCuotas) > 1) {
        for (let i = 1; i <= Number(this.liquidacion.totalCuotas); i++) {
          this.listCuotas.push(i);
        }
    }
  }

  sendCuota() {
    this.denvioData.enviarNumeroCuota(this.liquidacion.numCuota);
  }

  ngAfterViewInit() {
    //this.dataSource.sort = this.sort;
  }

  public obtenerDocsDefinitivos() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();

    let observablePresentados =
      this.dServicioRESTAPI.consultarFormulariosEstado("definitivo");
    observablePresentados.subscribe(
      (res) => {
        this.logger.info("Obteniendo Documentos Definitivos ", res);
        this.arrDocumentosDefinitivos = <DListaDocumentos>(
          res.listadoFormularios
        );
        this.dataDefinitivos = res.listadoFormularios;
        
        this.dataSource = new MatTableDataSource(
          this.dataDefinitivos["infoFormularios"]
        );
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case "num_formulario":
              return item["identificador"].id;
            case "diligenciado":
              return item["fecPresentacion"];

            default:
              return item[property];
          }
        };
        precarga.close();
        this.estadosCarga.definitivos = true;
      },
      (error) => {
        precarga.close();

        this.estadosCarga.definitivos = true;
      }
    );
  }

  /**
   * @desc Funcion para imprimir el formulario
   */
  imprimirFormulario(idFormulario: string) {
    this.operacionesGenerales.imprimirFormulario(idFormulario);
  }

  pagarFormulario(id, anio, periodo, modo, item,fraccionAnio) {
    const data = {
      id: id,
      anio: anio,
      periodo: periodo,
      modo: modo,
      item: item,
      fraccionAnio: fraccionAnio
    };
    this.generalService.enviarPagarFormulario(data);
    this.generalService.datosReciboPago$.subscribe(data => {
      this.contexto = data.contexto;
      this.fecha = data.fecha;
      this.liquidacion = data.liquidacion;
      this.mensajeAntesGuardar = data.mensajeAntesGuardar;
      this.pagoPSE = data.pagoPSE;
      this.tieneFirmaElectronica = data.tieneFirmaElectronica;
      this.pagando = true;
      if (this.liquidacion && parseInt(this.liquidacion.totalCuotas) > 1) {
        this.buildCuotas();
      }
    })
  }

  copiarFormulario(
    objetoFormulario: DInfoResumenFormulario,
    newForm: boolean = false
  ) {
    this.generalService.enviarCopiarFormulario(objetoFormulario);
  }

  /**
   * @desc Funcion para conocer si el contribuyente tiene firma electronica
   * @param {String} ideDocumento
   */
  public consultarFirmanteElectronico(ideDocumento: string) {
    let observableServicio =
      this.operacionesGenerales.consultarFirmanteElectronico(ideDocumento);
    observableServicio.subscribe((res) => {
      this.esFirmanteElectronico = <DFirmaElectronica>res;
      this.firmaRequerida = this.esFirmanteElectronico.esFirmaElectronica;
    });
  }
  /**
* @desc Funcion para verificar si el formulario debe de mostrar la seccion de fraccion de año
* @param {Number} anio
*/
private verificarFraccionAnio(anio:number) {
  let anioActual = (new Date()).getFullYear();
  this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;          
}

public obtenerVersionesRuta(ideFormato:number){
  let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
  let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
  observableVersionesFormato.subscribe(
      res => { 
          this.versionesRuta = <Array<DVersionRutaFormato>>res;
          let anio = 0;
          for(let version of this.versionesRuta){
              if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año                     
                  if (anio < version.anioGravable) anio = version.anioGravable; 
                  this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
              }
          }
          this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
          precargaProceso.close();
          this.enProceso = false;
      },
      error => {
          precargaProceso.close();
          this.enProceso = false;
          this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
      }
  );    
}

changeTab(tab: string) {
  const keys = Object.keys(this.tabs);
  keys.forEach(key => {
     this.tabs[key].value = false;
  })
  keys.forEach(key => {
    if (key === tab) {
      this.tabs[key].value = true;
      this.currentTab = this.tabs[key];
    }
  })
}

salirDePago(){
  this.pagando = false;
}
sendDate(){
  this.denvioData.enviarFechaPago(this.fechaPago);
}
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/definitivos/definitivos.component.ts